// @flow

import * as React from "react";
import { Component } from "react";
import ReactGA from "react-ga";

type Props = {
  title: string,
  children?: React.Node
};

type State = {
  open: boolean
};

class InlineTextLink extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      open: false
    };
  }

  open = (e: Event) => {
    e.preventDefault();
    this.setState({ open: true });
    ReactGA.event({
      category: "Task",
      action: "Open Review",
      label: this.props.title
    });
  };

  render() {
    if (this.state.open) {
      return <span>{this.props.children}</span>;
    } else {
      return (
        <a href="#open" onClick={this.open}>
          {this.props.title}
        </a>
      );
    }
  }
}

export default InlineTextLink;



// WEBPACK FOOTER //
// ./src/components/InlineTextLink/InlineTextLink.js